import { createOverlay } from '@vfde-brix/ws10/overlay';
import {
    openOverlay,
    closeOverlay,
    injectOverlayContent,
    fetchOverlay,
    selectOverlayContextForUrl,
} from '@vfde-sails/overlay';
import {
    trackIt,
    TrackType,
    TRACKING_INFORMATION_ACTION_REVEAL,
    TrackingInformationUiType,
    TrackingInformationTrigger,
} from '@vfde-sails/tracking';
import {
    OVERLAY_CONTAINER_ID,
    GIGAKOMBI_OVERLAY_NAME,
    DEEPLINK_SESSION_STORAGE_KEY,
} from '../../../app/constants';
import { startAppListening } from '../../../app/listener';
import { useAppDispatch } from '../../../app/store';
import { mountEditorialAccordions } from '../../../components/Accordion';
import { mountGigakombiOverlayButtons } from './ButtonForGigakombiOverlay';

/**
 * Prepares the overlay for being used
 */
export const prepareOverlay = () => {
    const dispatch = useAppDispatch();

    let container = document.getElementById(OVERLAY_CONTAINER_ID);

    /* istanbul ignore else */
    if (!container) {
        container = document.createElement('div');
        container.id = OVERLAY_CONTAINER_ID;

        document.body.appendChild(container);
    }

    const overlay = createOverlay(container, {
        optPaddingLayout: true,
        business: {
            onOpen: () => {
                dispatch(openOverlay());
            },
            onClose: () => {
                dispatch(closeOverlay());
            },
            onInject: () => {
                dispatch(injectOverlayContent());
            },
        },
    });

    startAppListening({
        actionCreator: fetchOverlay.fulfilled,
        effect: action => {
            /* istanbul ignore if */
            if (!action.payload.content) {
                return;
            }

            overlay.injectContent(action.payload.content);
        },
    });

    startAppListening({
        actionCreator: injectOverlayContent.fulfilled,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const context = selectOverlayContextForUrl(state);
            const trackingName = context?.trackingData.trackingName;
            const overlayContentContainer = overlay.getOverlayContentContainer();

            mountEditorialAccordions([], overlayContentContainer);

            if (trackingName === GIGAKOMBI_OVERLAY_NAME) {
                // Mount buttons in GK overlay
                mountGigakombiOverlayButtons(overlay);
            }

            overlay.open();
        },
    });

    startAppListening({
        actionCreator: openOverlay,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const context = selectOverlayContextForUrl(state);

            if (context?.trackingData) {
                trackIt(TrackType.Information, {
                    /* eslint-disable camelcase, @typescript-eslint/naming-convention */
                    information_action: TRACKING_INFORMATION_ACTION_REVEAL,
                    information_name: context.trackingData.trackingName,
                    information_ui_type: TrackingInformationUiType.Overlay,
                    information_trigger: TrackingInformationTrigger.Anchor,
                    /* eslint-enable camelcase, @typescript-eslint/naming-convention */
                });
            }
        },
    });

    startAppListening({
        actionCreator: closeOverlay,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState(); // TODO: check coverage
            const context = selectOverlayContextForUrl(state);
            const trackingName = context?.trackingData.trackingName;

            if (trackingName === GIGAKOMBI_OVERLAY_NAME) {
                // INC-34987: We need to remove the deeplink storage item so that it isn't transported to the basket if the user switches gk off again
                sessionStorage.removeItem(DEEPLINK_SESSION_STORAGE_KEY);
            }
        },
    });
};
